export const isUUIDType = (idType: string): boolean => idType === 'uuid' || idType === 'uuidv7'
